import Vue from 'vue'
import App from './App.vue'
import routes from './navroutes';
import VueRouter from "vue-router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//开启debug模式
Vue.config.debug = true;

Vue.use(VueRouter);
Vue.use(ElementUI);

const router = new VueRouter({
  mode: 'history',
  linkActiveClass:"active",
  base: __dirname,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

new Vue({
  router,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js